export default __webpack_public_path__ + "bannerImage.jpg";